import React from "react";
import { Navigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { useLang } from "../i18n/LanguageContext";

/**
 * Protège une route.
 * - sans `role` : il suffit d'être connecté avec un profil
 * - avec `role` : le rôle doit correspondre (0 = admin, 1 = prof, 2 = élève)
 */
const ProtectedRoute = ({ children, role }) => {
  const { user, loading } = UserAuth();
  const { t } = useLang();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-400">
        {t("Chargement...")}
      </div>
    );
  }

  if (!user || !user.hasProfile) return <Navigate to="/signin" replace />;
  if (role !== undefined && user.role !== role) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
